import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaDocumentosLayoutsh2hLayout', NominaDocumentosLayoutsh2hLayout)

function NominaDocumentosLayoutsh2hLayout ($http) {
  this.get = function (idEmpresa, idNomina, idLayout) {
    return $http.get('/api/nominas/nomina/documentos/layoutsh2h/layout', {
      params: {
        id_empresa: idEmpresa,
        id_nomina: idNomina,
        id_layout: idLayout,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.delete = function (idEmpresa, idNomina, idLayout, ids) {
    return $http.delete('/api/nominas/nomina/documentos/layoutsh2h/layout', {
      params: {
        id_empresa: idEmpresa,
        id_nomina: idNomina,
        id_layout: idLayout,
        ids: ids,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.schema = {
    'layout': {
      indice: 'number',
      total: 'number',
      total_aplicado: 'number',
      captura_fecha: 'timestamp',
      procesado_fecha: 'timestamp',
      completado_fecha: 'timestamp',
      error: 'boolean',
    },
    'pagos': {
      id_pago: 'number',
      importe: 'number',
      pendiente: 'boolean',
      interbancario: 'boolean',
      detalle_error: 'boolean',
    },
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Layoutsh2h/Layout.js